// Vite entry point
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@ant-design/v5-patch-for-react-19';
import App from '@app/App';
import '@/main.css';

if (typeof document !== 'undefined') {
    const faviconLink = document.querySelector("link[rel='icon']");
    const darkModeQuery = window.matchMedia('(prefers-color-scheme: dark)');

    const applySystemThemeFavicon = () => {
        if (!faviconLink) return;
        const faviconPath = darkModeQuery.matches ? '/dark_favicon.png' : '/favicon.png';
        faviconLink.setAttribute('href', faviconPath);
    };

    if (faviconLink && darkModeQuery) {
        applySystemThemeFavicon();

        if (typeof darkModeQuery.addEventListener === 'function') {
            darkModeQuery.addEventListener('change', applySystemThemeFavicon);
        } else if (typeof darkModeQuery.addListener === 'function') {
            darkModeQuery.addListener(applySystemThemeFavicon);
        }
    }
}

createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
